export default function(socketFactory, $injector) {
	this.AppConfig = $injector.get('app.config');

	let socketPath = this.AppConfig.server.socketIO.https ? 'https://' : 'http://';
	socketPath += this.AppConfig.server.socketIO.ip + ':' + this.AppConfig.server.socketIO.port + '/';
    socketPath += this.AppConfig.server.socketIO.nsp;

	/*
	 * Hash the key stored in the app config file with the secret and send it to the SocketIO-Server
	 */
	let encryptedToken = CryptoJS.AES.encrypt(this.AppConfig.server.auth.key, this.AppConfig.server.auth.secret);

	return socketFactory({
		ioSocket: io.connect(socketPath, {
			query: 'token='+encryptedToken.toString()
		})
	});
}
